import footerScripts from "./directive";
import siteImproveLoader from "./siteimprove/";

const modul = angular
    .module("footerScripts", [])

    .directive("footerScripts", footerScripts)
    .factory("siteImproveLoader", siteImproveLoader);

export default modul.name;
